export const isBusinessClose = (restaurantData) => {
  return restaurantData?.delivery === true ?
    (restaurantData?.restaurant?.delivery_schedule_by_ranges_activated === false) :
    (restaurantData?.restaurant?.table_schedule_by_ranges_activated === false)
}
